import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { useApiClient } from "@/context/api-client";
import { CommonQueryKeys } from "@/hooks/queries/keys";

export const useQueryStartCalling = () => {
  const api = useApiClient();

  const dataApi = useQuery({
    queryKey: CommonQueryKeys.startCallingModal,
    queryFn: api.getStartCallingModalData,
  });

  useEffect(() => {
    if (dataApi.isError) {
      toast.error("Failed to load your lists, please try to reload the page.");
    }
  }, [dataApi.isError]);

  return dataApi;
};
